import React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useAuth } from '../../hooks/useAuth'; // تأكد من وجود هذا الـ hook
import { LoginData } from '../../services/authService';
import styles from './AuthPage.module.css'; // استخدم نفس ملف التنسيق

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<LoginData>();

  const onSubmit: SubmitHandler<LoginData> = async (data) => {
    console.log('--- 🕵️‍♂️ [FRONTEND] Login attempt started ---');
    
    try {
      // لا نستخدم toast.promise الآن للتشخيص
      toast.loading('جاري تسجيل الدخول...');
      
      await login(data); // استدعاء دالة login من السياق
      
      toast.dismiss(); // إخفاء رسالة التحميل
      toast.success('تم تسجيل الدخول بنجاح!');
      console.log('✅ [FRONTEND] Login function in context completed successfully.');
      
      navigate('/'); // توجيه المستخدم إلى لوحة التحكم
      
    } catch (error: any) {
      toast.dismiss(); // إخفاء رسالة التحميل
      
      // !! أهم جزء: طباعة الخطأ الفعلي الذي تم التقاطه !!
      console.error('❌ [FRONTEND] Error caught in LoginPage:', error);
      
      const errorMessage = error.response?.data?.message || 'فشل تسجيل الدخول. تحقق من بياناتك.';
      toast.error(errorMessage);
    }
  };

  return (
    <div className={styles.pageContainer}>
      <div className={styles.formContainer}>
        <h2 className={styles.title}>تسجيل الدخول</h2>
        <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
          <div className={styles.formField}>
            <label htmlFor="email" className={styles.label}>البريد الإلكتروني</label>
            <input
              id="email"
              type="email"
              {...register('email', { required: 'البريد الإلكتروني مطلوب' })}
              className={styles.input}
            />
            {errors.email && <p className={styles.error}>{errors.email.message}</p>}
          </div>

          <div className={styles.formField}>
            <label htmlFor="password" className={styles.label}>كلمة المرور</label>
            <input
              id="password"
              type="password"
              {...register('password', { required: 'كلمة المرور مطلوبة' })}
              className={styles.input}
            />
            {errors.password && <p className={styles.error}>{errors.password.message}</p>}
          </div>

          <button type="submit" disabled={isSubmitting} className={styles.submitButton}>
            {isSubmitting ? 'جاري الدخول...' : 'دخول'}
          </button>
        </form>
        <p className={styles.linkText}>
          ليس لديك حساب؟ <Link to="/register">أنشئ حساباً جديداً</Link>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
